
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../components-css/WeBelieve.css';

const WeBelieve = () => {
  const [beliefs, setBeliefs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/beliefs.json')
      .then(res => setBeliefs(res.data))
      .catch(() => setBeliefs([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-center my-5"><Spinner animation="border" /></div>;

  return (
    <section id="en-que-creemos" className="we-believe py-5">
      {/* Se eliminaron todas las imágenes de we-believe */}
      <div className="we-believe-map"></div>
      <Container>
        <div className="section-title text-center mb-5">
          <h2 className="section-title__title">En qué creemos</h2>
        </div>
        <Row className="justify-content-center">
          {beliefs.map((b, idx) => (
            <Col key={b.title} md={3} className="mb-4">
              <Card className="text-center h-100">
                <Card.Body>
                  <div className={`we-believe__icon mb-3`}><span className={b.icon}></span></div>
                  <Card.Title>{b.title}</Card.Title>
                  <Card.Text>{b.text}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <div className="we-believe__cta text-center">
          <Link className="we-believe__link" to="/declaracion-de-fe">
            Ver nuestra declaración de fe completa
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default WeBelieve;
